import template from "./index.html";
import "./index.less";
import { EVENT_LOGOUT } from "../../../constants";
import { groupBy } from "lodash";
import moment from "moment";
import exportActions from "../../export-actions/export-actions";

//terms
function controller($scope, eventBus, $logger, appState) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;
	ctrl.showMore = {};

	function onInit() {
		eventBus.register(EVENT_LOGOUT, () => { handleClose(); }, $scope);

		ctrl.isSysAdmin = appState.operatingUserRole === "SYSADMIN";
		ctrl.formId = appState.forms.selected.Id;
		ctrl.reportId = ctrl.resolve.report.Id;

		ctrl.exportsByConfiguration = groupBy(ctrl.resolve.exports, e => (e.Log.Configuration.Name ?? e.Log.Configuration.Code));
		Object.values(ctrl.exportsByConfiguration)
			.forEach(exports => {
				exports.forEach(e => {
					const result = e.IsCommitted === true 
						? { statusClass: "zmdi-check-square bfd-dark-green", statusText: "Committed" }
						: e.IsCommitted === false || e.IsSuppressed === true
							? { statusClass: "zmdi-alert-triangle text-danger", statusText: "Error" }
							: { statusClass: "zmdi-info bfd-caution", statusText: "Pending" };

					e.statusClass = result.statusClass;
					e.statusText = result.statusText;
				});
				(exports ?? []).sort((a, b) => moment(a.Log.Created).isAfter(moment(b.Log.Created)) ? -1 : 1); 
			});
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}
}

export { singleExportDetail } from "./single-export-detail";
export const exportInformationModal = angular
	.module("vesl.components.export-information", [exportActions])
	.component("exportInformation", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;